import { object } from "yup";
const buildValidationSchema = (fields) => {
  return object().shape(
    Object.fromEntries(
      Object.values(fields).map((settings) => [settings.name, settings.validation]).filter(([_, validation]) => Boolean(validation))
    )
  );
};
export {
  buildValidationSchema
};
